const ModalsTestIdsScope = {
  MODALS: 'modals',
};

export const ModalsTestIds = {
  MODAL_CONFIRMATION_DIALOG: `${ModalsTestIdsScope.MODALS}.confirmation-dialog`,
};
